import { faBriefcase, faBuilding, faFolder, faFolderTree, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

export const getExpertInIcon = (key) => {
    switch (key) {
        case 1:
            return { icon: faFolder };
        case 2:
            return { icon: faBuilding };
        case 3:
            return { icon: faBriefcase };
        case 4:
            return { icon: faFolderTree };
        default:
            return { icon: faQuestionCircle };
    }
};

// Maps Foley v12 combination expertType IDs to individual dimension IDs.
// Foley's potentialProjectExpertType has 7 rows (all subsets of 3 dimensions).
// Individual dimensions: 1=AOL, 2=Client, 3=Industry
const EXPERT_TYPE_DIMENSIONS = {
    1: [1, 2, 3], // aol & client & industry
    2: [1, 2],    // aol & client
    3: [1, 3],    // aol & industry
    4: [2, 3],    // client & industry
    5: [1],       // aol
    6: [2],       // client
    7: [3],       // industry
};

/**
 * Returns the individual dimension IDs included in a combination expertType ID.
 * Falls back to treating the ID itself as a dimension (backward compat with non-Foley customers).
 * @param {number|string} combinationId - The expertType id from the API
 * @returns {number[]} Array of individual dimension IDs
 */
export const getExpertDimensions = (combinationId) => {
    if (combinationId == null) return [];
    const id = parseInt(combinationId, 10);
    if (isNaN(id)) return [];
    return EXPERT_TYPE_DIMENSIONS[id] ?? [id];
};
